import { render, staticRenderFns } from "./ClaimSuccess.vue?vue&type=template&id=39a35f03&scoped=true"
import script from "./ClaimSuccess.vue?vue&type=script&lang=js"
export * from "./ClaimSuccess.vue?vue&type=script&lang=js"
import style0 from "./ClaimSuccess.vue?vue&type=style&index=0&id=39a35f03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a35f03",
  null
  
)

export default component.exports